// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2SoK7","title":"BackImages_title__1bO9f","images":"BackImages_images__2KkcW"};